import React from 'react';
import Paper from 'material-ui/Paper';
import {cloneDeep} from 'lodash';
import SocialNotifications from 'material-ui/svg-icons/social/notifications';

const paperStyle = {
	// marginTop: 10,
	padding: 15,
	    // display: 'flex',
    flexDirection: 'row wrap',
    width: '100%',
    boxShadow: 'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px',
    maxHeight:150,
    overflowY:'auto'
};

const styles = {
	errors:{
		color:'red'
	},
	alerts:{
		color:'#ff7a00'
	},
	iconStyle:{
		color:'inherit',
		height:19,
		width:19,
		marginRight:7,
		verticalAlign:'text-bottom',
	}

}
// lalalala
export default class ErrorView extends React.Component {

	constructor(props) {
		super(props)
		this.state = {errors:this.props.errors}
	}

	componentWillUpdate = (nextProps, nextState) =>{

		if(this.props.errors != nextProps.errors){
			this.setState({errors:nextProps.errors})
		}
	}

	render(){

		const errorsList = this.state.errors.map(function(e,index){
			return <div style={styles.errors} key={index}>
						<SocialNotifications style={styles.iconStyle}/>
						<span>{e}</span>
					</div>
		})
		const alertsList = this.props.alerts.map(function(e,index){
			return <div style={styles.alerts} key={index}>
						<SocialNotifications style={styles.iconStyle}/>
						<span>{e}</span>
					</div>	
		})

		const style = cloneDeep(this.props.style)

		return(
			<div style={style} >
				<Paper style={paperStyle}>					
					<div >
						{alertsList}
					</div>
					<div  >
						{errorsList}
					</div>
				</Paper>
			</div>
		);		

	}
}


// WEBPACK FOOTER //
// ./src/js/components/ErrorView.js